import { useToast } from '@chakra-ui/react'
import styled from 'styled-components'

import { Alert, Close } from 'icon'

export const useMessage = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const msg = useToast({
    position: 'top',
    duration: 3000,
    render: ({ title } = {}) => (
      <Message>
        <Alert />
        <ErrorText>{title}</ErrorText>
        <span onClick={onClose}>
          <Close />
        </span>
      </Message>
    ),
  })

  const onClose = () => {
    msg.closeAll()
  }

  return msg
}

const Message = styled.div`
  font-size: 16px;
  text-align: center;
  height: 62px;
  width: 380px;
  padding: 0px 12px;

  background-color: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
`

const ErrorText = styled.div`
  width: 100%;
  text-align: left;
  padding-left: 8px;
  font-family: 'NotoSansThai';
`
